import { render, staticRenderFns } from "./ModalEditSchool.vue?vue&type=template&id=58afc1ae&scoped=true"
import script from "./ModalEditSchool.vue?vue&type=script&lang=js"
export * from "./ModalEditSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58afc1ae",
  null
  
)

export default component.exports